import { RouteFactory } from "@app/routePaths";
import { usePreferredEdition } from "@features/banner/Edition/hooks/usePreferredEdition";

/**
 * Hook to get the link for the homepage masthead based on the user's preferred edition.
 */
export const useHomeLink = () => {
  const { edition } = usePreferredEdition();
  const isSgPreferred = edition === "SG";

  if (isSgPreferred) return RouteFactory.home;

  return RouteFactory.global;
};
